<template>
    <div class="homePage">
        <div class="top">
            <img src="../img/logo.png" alt="">
        </div>
        <div class="homeMain">
            <img src="../img/title.png" alt="" class="titleImg">
            <!-- <div class="liveWrap">
                <div class="liveCon" @click="openLive()">
                    <img src="../img/livecircle.png" alt="" id="myIcon">
                    <img src="../img/liveplay.png" alt="" class="livePlay">
                    <span>大会开幕式正在直播</span>
                </div>
            </div> -->
            
            <div class="timeAndLocation">
                <img src="../img/clockicon.png" alt="">
                <span class="time">2019年12月9-10日</span>
                <img src="../img/location.png" class="location" alt="">
                <span>
                    中国 • 长沙
                </span>
                <div class="organizer">
                    主办单位：中华人民共和国教育部&nbsp;&nbsp; 湖南省人民政府
                </div>
                <div class="organizer_1">
                    承办单位：孔子学院总部 &nbsp;&nbsp;世界汉语教学学会&nbsp;&nbsp;湖南省教育厅 &nbsp;&nbsp;长沙市人民政府等
                </div>
            </div>
            <div class="copyRight">
                版权所有 © 2019 孔子学院总部     京ICP 备 08002516号-5
            </div>
        </div>
        <div class="videoPlayCon" v-if="isPlay">
            <div class="playBg"></div>
            <img src="../img/close_white.png" alt="" @click="closeLive()">
            <video ref="liveVideo" src="http://tourism.chinesecio.com/hainanvideo/hainan1.mp4" controls></video>
        </div>

       
    </div>
</template>

<script>
export default {
  name: 'home',
  data:function() {
      return {
          isPlay: false
      }
  },
  methods: {
      closeLive () {
          this.$refs.liveVideo.pause()
          this.isPlay = false
      },
      openLive () {
            this.isPlay = true
            this.$nextTick(() => {
                this.$refs.liveVideo.play()
            })
            
      }
  },
  mounted () {
      setTimeout(()=> {
          //this.$router.push('/pcpage/mainpage/news')
      }, 3000)
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#myIcon {
    -webkit-animation: rotation 2s infinite linear;
}

@-webkit-keyframes rotation {
    from {-webkit-transform: rotate(0deg);}
    to   {-webkit-transform: rotate(359deg);}
}
.homePage {
    text-align: center;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    .top {
        text-align: left;
        img {
            width: 182px;
            margin-left: 55px;
            padding-top: 30px;
        }
        
    }
    .titleImg {
       padding-top: 150px;
       width: 60%;
       margin: auto;
   }
   .homeMain {
       text-align: center;
       padding-left: 100px;
       .liveWrap {
           margin-top: 30px;
           text-align: center;
       }
       .liveCon {
           display: inline-flex;
           align-items: center;
           justify-content: center;
           width: 241px;
           height: 81px;
           background-color: rgba(255, 255, 255, 0.1);
            box-shadow: 0px 3px 10px 0px 
                rgba(0, 0, 0, 0.05);
            border-radius: 20px;
            border: solid 2px rgba(148, 222, 255, 0.1);
            cursor: pointer;
            span {
                display: inline-block;
                width: 5em;
                white-space: initial;
                text-align: left;
                margin-left: 10px;
                color: #f3bc65;
                line-height: 1.2;
           
            }
            .livePlay {
                transform: translateX(-30px);
            }

       }
   }
   .timeAndLocation {
       margin-top: 80px;
       line-height: 34px;
       vertical-align: top;
       img {
            width: 34px;
            vertical-align: top;
       }
       .location {
           width: 26px;
       }
       span {
           color: #fff;
           margin-left: 27px;
       }
       .time {
           margin-right: 77px;
       }
      
   }
   .organizer {
       color: #fff;
       font-size: 24px;
       margin-top: 52px;
       font-weight: bold;
       line-height: 36px;
   }
   .organizer_1 {
       color: #fff;
       font-size: 24px;
       font-weight: bold;
       margin-top: 0;
   }
   .copyRight {
       margin-top: 69px;
       font-size: 16px;
       color: #fff;

   }
}
.videoPlayCon {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    div {
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.7);
    }
    video {
        width: 50%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
    }
    img {
        position: absolute;
        top: 50px;
        right: 50px;
        width: 40px;
        cursor: pointer;
    }
    
}
@media screen and (min-width: 1240px) and (max-width: 1600px) {
.homePage  {
    .top {
        img {
            width: 148px;
        }
    }
    .titleImg {
        padding-top: 105px;
        width: 60%;
    }
    .organizer {
        margin-top: 20px;
    }
    .organizer,.organizer_1 {
        font-size: 18px;
    }
    .copyRight {
        margin-top: 15px;
    }
    .timeAndLocation {
        margin-top: 25px;
    }
}

  
}
@media screen and (min-width: 1460px) and (max-width: 1660px) {
.homePage  {
    .top {
        img {
            width: 148px;
        }
    }
    .titleImg {
        padding-top: 150px;
        width: 60%;
    }
    .organizer {
        margin-top: 20px;
    }
    .organizer,.organizer_1 {
        font-size: 20px;
    }
    .copyRight {
        margin-top: 20px;
    }
    .timeAndLocation {
        margin-top: 35px;
    }
}

  
}
</style>
